import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
import classifyShowList from './views/classify/classifyShowList.vue'
import memberClassifyShowList from './views/classify/classifyShowList1.vue'
import Register from './views/Register.vue';

let routes = [
    {
        path: '/',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true,
        props: (route) => ({backUrl: route.query.backUrl}),
    },
    {
        path: '/register',
        component: Register,
        name: '',
        hidden: true
    },
    {
        path: '/index',
        component: classifyShowList,
        hidden: true,
        props: (route) => ({classifyId: route.query.classifyId}),
    },
    {
        path: '/analysisIndex',
        component: classifyShowList,
        hidden: true,
        props: (route) => ({classifyId: route.query.classifyId, type: 'ANALYSIS'}),
    },
    {
        path: '/standardIndex',
        component: classifyShowList,
        hidden: true,
        props: (route) => ({classifyId: route.query.classifyId, type: 'STANDARD'}),
    },
    {
        path: '/member/index',
        component: memberClassifyShowList,
        hidden: true,
        props: (route) => ({classifyId: route.query.classifyId}),
    },
    {
        path: '/member/analysisIndex',
        component: memberClassifyShowList,
        hidden: true,
        props: (route) => ({classifyId: route.query.classifyId, type: 'ANALYSIS'}),
    },
    {
        path: '/member/standardIndex',
        component: memberClassifyShowList,
        hidden: true,
        props: (route) => ({classifyId: route.query.classifyId, type: 'STANDARD'}),
    },
    {
        path: '/deviceShowList',
        component: resolve => require(['./views/device/deviceShowList.vue'], resolve),
        hidden: true,
        props: (route) => ({classifyId: route.query.classifyId, lastParentId: route.query.lastParentId, isMember: route.query.isMember}),
    },
    {
        path: '/analysisShowList',
        component: resolve => require(['./views/analysis/analysisShowList.vue'], resolve),
        hidden: true,
        props: (route) => ({classifyId: route.query.classifyId, isMember: route.query.isMember}),
    },
    {
        path: '/standardShowList',
        component: resolve => require(['./views/standard/standardShowList.vue'], resolve),
        hidden: true,
        props: (route) => ({classifyId: route.query.classifyId, isMember: route.query.isMember}),
    },
    {
        path: '/articleShowList',
        component: resolve => require(['./views/creator/articleShowList.vue'], resolve),
        hidden: true,
        props: () => ({}),
    },
    {
        path: '/articleShowDetail',
        component: resolve => require(['./views/creator/article/articleDetail.vue'], resolve),
        hidden: true,
        props: (route) => ({articleId: route.query.articleId}),
    },
    {
        path: '/articleCreate',
        component: resolve => require(['./views/creator/article/articleCreate.vue'], resolve),
        hidden: true,
        props: (route) => ({articleId: route.query.articleId}),
    },
    {
        path: '/article/myList',
        component: resolve => require(['./views/creator/article/myArticleList.vue'], resolve),
        hidden: true,
        props: (route) => ({articleId: route.query.articleId}),
    },
    {
        path: '/articleUpdate',
        component: resolve => require(['./views/creator/article/articleCreate.vue'], resolve),
        hidden: true,
        props: (route) => ({articleId: route.query.articleId}),
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    {
        path: '/',
        component: Home,
        hidden: true,
        children: [
            {
                path: '/staHome',
                component: resolve => require(['./views/staHome.vue'], resolve),
                hidden: true,
            },
        ],
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa el-icon-tickets',
        leaf: true,
        children: [
            {
                path: '/classifyList',
                component: resolve => require(['./views/classify/classifyTab.vue'], resolve),
                name: '器件分类'
            },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '器件信息',
        iconCls: 'fa el-icon-s-order',
        leaf: false,
        hidden: false,
        children: [
            {
                path: '/deviceList',
                component: resolve => require(['./views/device/deviceList.vue'], resolve),
                name: '器件列表',
                props: (route) => ({classifyId: route.query.classifyId ? route.query.classifyId : '1769572002597933058', type: '1'}),
            },
            {
                path: '/competitorList',
                component: resolve => require(['./views/device/deviceList.vue'], resolve),
                name: '竞品列表',
                props: (route) => ({classifyId: route.query.classifyId ? route.query.classifyId : '1769572002597933058', type: '2'}),
            },
            {
                path: '/characteristicsTypeList',
                component: resolve => require(['./views/characteristics/characteristicsTypeList.vue'], resolve),
                name: '特性类型'
            },
            {
                path: '/analysisList',
                component: resolve => require(['./views/analysis/analysisList.vue'], resolve),
                name: '标准解析列表'
            },
            {
                path: '/standardList',
                component: resolve => require(['./views/standard/standardList.vue'], resolve),
                name: '通用规范列表'
            },
        ]
    },
    {
        path: '/',
        hidden: true,
        component: Home,
        name: '特性参数',
        children: [
            {
                path: '/characteristicsParamList',
                component: resolve => require(['./views/characteristics/characteristicsParamList.vue'], resolve),
                name: '特性参数',
                props: (route) => ({deviceId: route.query.deviceId, classifyId: route.query.classifyId}),
            },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'fa el-icon-edit-outline',
        leaf: true,
        children: [
            {
                path: '/consultList',
                component: resolve => require(['./views/consult/consultList.vue'], resolve),
                name: '咨询列表'
            },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '论坛管理',
        iconCls: 'fa fa-comments-o',
        leaf: false,
        hidden: false,
        children: [
            {
                path: '/articleLabelList',
                component: resolve => require(['./views/creator/article/articleLabelList.vue'], resolve),
                name: '文章标签'
            },
            {
                path: '/articleList',
                component: resolve => require(['./views/creator/article/articleList.vue'], resolve),
                name: '文章列表',
            },
        ]
    },
    {
        path: '/',
        hidden: true,
        component: Home,
        name: '文章审核',
        children: [
            {
                path: '/article/approve',
                component: resolve => require(['./views/creator/article/articleApprove.vue'], resolve),
                name: '文章审核',
                props: (route) => ({articleId: route.query.articleId, isApprove: true, hideHeader: true}),
            },
        ]
    },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '',
    //     iconCls: 'fa el-icon-document',
    //     leaf: false,
    //     children: [
    //         {
    //             path: '/pdfWorkbench',
    //             component: resolve => require(['./views/tools/pdfWorkbench.vue'], resolve),
    //             name: 'PDF批注工作台'
    //         },
    //         {
    //             path: '/xofficeFormWorkbench',
    //             component: resolve => require(['./views/tools/xofficeFormWorkbench.vue'], resolve),
    //             name: 'XOffice表单工作台'
    //         },
    //     ]
    // },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js